import { DestinationEvent, FormattedEventResponse } from '@eb/event-renderer';
const _destinationEventList: DestinationEvent[] = [
    {
        image: {
            edge_color_set: true,
            edge_color: '#68676a',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F122020957%2F239331669958%2F1%2Foriginal.20200624-185744?w=466&auto=format%2Ccompress&q=75&sharp=10&rect=2%2C0%2C466%2C233&s=a456a986015ee86df75a4e97d42369e4',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F122020957%2F239331669958%2F1%2Foriginal.20200624-185744?auto=format%2Ccompress&q=75&sharp=10&s=5c1956f8beefaeea824a9cc19344977c',
                width: 470,
                height: 233,
            },
            crop_mask: {
                width: 466,
                height: 233,
                top_left: {
                    y: 0,
                    x: 2,
                },
            },
            aspect_ratio: '2',
            id: '122020957',
        },
        timezone: 'Europe/Berlin',
        id: '153013731189',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=153013731189',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '30575694064',
        num_children: 12,
        parent_url:
            'https://www.eventbrite.de/e/arabischsprachiges-freitagsgebet-izm-1330-tickets-134911781771',
        hide_end_date: false,
        start_date: '2021-05-21',
        end_time: '14:00',
        _type: 'destination_event',
        end_date: '2021-05-21',
        tags: [
            {
                prefix: 'EventbriteSubCategory',
                tag: 'EventbriteSubCategory/14003',
                display_name: 'Islam',
            },
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/114',
                display_name: 'Religion & Spirituality',
                localized: {
                    display_name: 'Religion & Spirituality',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/12',
                display_name: 'Rally',
            },
            {
                tag: 'OrganizerTag/Islam',
                display_name: 'Islam',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Gebet',
                display_name: 'Gebet',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Allah',
                display_name: 'Allah',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Salah',
                display_name: 'Salah',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '153013731189',
        start_time: '13:30',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Freimann-Moschee',
            venue_profile_id: null,
            address: {
                city: 'München',
                country: 'DE',
                region: 'BY',
                longitude: '11.6340722',
                localized_address_display: 'Wallnerstraße 1-3, 80939 München',
                postal_code: '80939',
                address_1: 'Wallnerstraße 1-3',
                latitude: '48.21036230000001',
                localized_multi_line_address_display: [
                    'Wallnerstraße 1-3',
                    '80939 München',
                ],
                localized_area_display: 'München',
            },
            venue_profile_url: '',
            id: '55873985',
        },
        image_id: '122020957',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '55873985',
        checkout_flow: 'widget',
        series_id: '134911781771',
        name: 'Arabischsprachiges Freitagsgebet IZM 13:30',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/arabischsprachiges-freitagsgebet-izm-1330-tickets-153013731189',
        hide_start_date: false,
        summary:
            'Tickets für das 1. Freitagsgebet um 13:30 Uhr (arabisch mit deutscher Synchronübersetzung).\n\nAnmeldung notwendig!',
        is_online_event: false,
        eid: '153013731189',
        published: '2021-01-02T04:59:19Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#68676a',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F122021101%2F239331669958%2F1%2Foriginal.20200624-185744?w=466&auto=format%2Ccompress&q=75&sharp=10&rect=2%2C0%2C466%2C233&s=d4f460a0e505ae219390939f8bbb3443',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F122021101%2F239331669958%2F1%2Foriginal.20200624-185744?auto=format%2Ccompress&q=75&sharp=10&s=3ee15e6763e76ef2bb51a3c8d0a5cd2a',
                width: 470,
                height: 233,
            },
            crop_mask: {
                width: 466,
                height: 233,
                top_left: {
                    y: 0,
                    x: 2,
                },
            },
            aspect_ratio: '2',
            id: '122021101',
        },
        timezone: 'Europe/Berlin',
        id: '153014619847',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=153014619847',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '30575694064',
        num_children: 12,
        parent_url:
            'https://www.eventbrite.de/e/deutschsprachiges-freitagsgebet-izm-1500-tickets-134911886083',
        hide_end_date: false,
        start_date: '2021-05-21',
        end_time: '15:30',
        _type: 'destination_event',
        end_date: '2021-05-21',
        tags: [
            {
                prefix: 'EventbriteSubCategory',
                tag: 'EventbriteSubCategory/14003',
                display_name: 'Islam',
            },
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/114',
                display_name: 'Religion & Spirituality',
                localized: {
                    display_name: 'Religion & Spirituality',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/12',
                display_name: 'Rally',
            },
            {
                tag: 'OrganizerTag/Islam',
                display_name: 'Islam',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Gebet',
                display_name: 'Gebet',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Allah',
                display_name: 'Allah',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Salah',
                display_name: 'Salah',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '153014619847',
        start_time: '15:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Freimann-Moschee',
            venue_profile_id: null,
            address: {
                city: 'München',
                country: 'DE',
                region: 'BY',
                longitude: '11.6340722',
                localized_address_display: 'Wallnerstraße 1-3, 80939 München',
                postal_code: '80939',
                address_1: 'Wallnerstraße 1-3',
                latitude: '48.21036230000001',
                localized_multi_line_address_display: [
                    'Wallnerstraße 1-3',
                    '80939 München',
                ],
                localized_area_display: 'München',
            },
            venue_profile_url: '',
            id: '55874063',
        },
        image_id: '122021101',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '55874063',
        checkout_flow: 'widget',
        series_id: '134911886083',
        name: 'Deutschsprachiges Freitagsgebet IZM 15:00',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/deutschsprachiges-freitagsgebet-izm-1500-tickets-153014619847',
        hide_start_date: false,
        summary:
            'Tickets für das 2. Freitagsgebet um 15:00 Uhr (deutsch ohne Übersetzung).\n\nAnmeldung notwendig!',
        is_online_event: false,
        eid: '153014619847',
        published: '2021-01-01T22:32:26Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#333333',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F129136425%2F324510411403%2F1%2Foriginal.20210315-184955?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=839fe0ecef83b4c57abd565492652376',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F129136425%2F324510411403%2F1%2Foriginal.20210315-184955?auto=format%2Ccompress&q=75&sharp=10&s=30b3c404c88739e2eca3e421127030a3',
                width: 2160,
                height: 1080,
            },
            crop_mask: {
                width: 2160,
                height: 1080,
                top_left: {
                    y: 0,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '129136425',
        },
        timezone: 'Europe/Berlin',
        id: '146481491083',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=146481491083',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '26165937343',
        num_children: 1,
        hide_end_date: false,
        start_date: '2022-07-23',
        end_time: '01:30',
        _type: 'destination_event',
        end_date: '2022-07-24',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/103',
                display_name: 'Music',
                localized: {
                    display_name: 'Music',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/5',
                display_name: 'Festival or Fair',
            },
            {
                tag: 'OrganizerTag/Party',
                display_name: 'Party',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Festival',
                display_name: 'Festival',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Sommer',
                display_name: 'Sommer',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Openair',
                display_name: 'Openair',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Gaimersheim',
                display_name: 'Gaimersheim',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Vize',
                display_name: 'Vize',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/dj_antoine',
                display_name: 'dj_antoine',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/cosmema_ug',
                display_name: 'cosmema_ug',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/open_air_gaimersheim',
                display_name: 'open_air_gaimersheim',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/openairgaimersheim',
                display_name: 'openairgaimersheim',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '146481491083',
        start_time: '18:30',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Festplatz Gaimersheim',
            venue_profile_id: null,
            address: {
                city: 'Gaimersheim',
                country: 'DE',
                region: 'BY',
                longitude: '11.3626285',
                localized_address_display: 'Römerstraße 42, 85080 Gaimersheim',
                postal_code: '85080',
                address_1: 'Römerstraße',
                latitude: '48.8029315',
                localized_multi_line_address_display: [
                    'Römerstraße',
                    '42',
                    '85080 Gaimersheim',
                ],
                localized_area_display: 'Gaimersheim',
            },
            venue_profile_url: '',
            id: '57949343',
        },
        image_id: '129136425',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '57949343',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Open Air Gaimersheim 2022',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/open-air-gaimersheim-2022-tickets-146481491083',
        hide_start_date: false,
        summary:
            "Das große Open Air Gaimersheim am 23.07.2022 mit Superstar-DJ's: DJ Antoine, VIZE Music uvm. Sichere dir jetzt die limitierten VVK-Tickets!",
        is_online_event: false,
        eid: '146481491083',
        published: '2021-03-15T18:55:28Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#2d437e',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F128187737%2F515864798929%2F1%2Foriginal.20210306-090352?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=c059998560f3c46eb06f1ded44f98743',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F128187737%2F515864798929%2F1%2Foriginal.20210306-090352?auto=format%2Ccompress&q=75&sharp=10&s=c282e407d2e38fd11cce240ba13d5dbc',
                width: 2160,
                height: 1080,
            },
            crop_mask: {
                width: 2160,
                height: 1080,
                top_left: {
                    y: 0,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '128187737',
        },
        timezone: 'Europe/Berlin',
        id: '142212016971',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=142212016971',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '32607464593',
        num_children: 1,
        hide_end_date: false,
        start_date: '2021-10-21',
        end_time: '19:00',
        _type: 'destination_event',
        end_date: '2021-10-21',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/101',
                display_name: 'Business & Professional',
                localized: {
                    display_name: 'Business & Professional',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/10',
                display_name: 'Meeting or Networking Event',
            },
            {
                tag: 'OrganizerTag/Investment',
                display_name: 'Investment',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Investor',
                display_name: 'Investor',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Entrepreneurship',
                display_name: 'Entrepreneurship',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Startup',
                display_name: 'Startup',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Entrepreneur',
                display_name: 'Entrepreneur',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Startups',
                display_name: 'Startups',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Pitch',
                display_name: 'Pitch',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Unternehmer',
                display_name: 'Unternehmer',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '142212016971',
        start_time: '16:30',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Bürgerhaus und Bürgersaal Ergolding',
            venue_profile_id: null,
            address: {
                city: 'Ergolding',
                country: 'DE',
                region: 'BY',
                longitude: '12.1692',
                localized_address_display: 'Lindenstraße 40, 84030 Ergolding',
                postal_code: '84030',
                address_1: 'Lindenstraße 40',
                latitude: '48.57687',
                localized_multi_line_address_display: [
                    'Lindenstraße 40',
                    '84030 Ergolding',
                ],
                localized_area_display: 'Ergolding',
            },
            venue_profile_url: '',
            id: '57218779',
        },
        image_id: '128187737',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '57218779',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Roadshow THE GROW - FINALE in Landshut',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/roadshow-the-grow-finale-in-landshut-tickets-142212016971',
        hide_start_date: false,
        summary:
            'Erleben Sie das große Finale von The Grow: Die Highlight-Abschlussveranstaltung mit Verleihung des invest2grow-Awards – live in Landshut.',
        is_online_event: false,
        eid: '142212016971',
        published: '2021-02-19T13:01:10Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#4e5046',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F125714361%2F287686250115%2F1%2Foriginal.20210210-072120?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=9f2e4c6aa5b7d334376b03f91efe478f',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F125714361%2F287686250115%2F1%2Foriginal.20210210-072120?auto=format%2Ccompress&q=75&sharp=10&s=cd49b15c727f3e63365a5d0042de331f',
                width: 2160,
                height: 1080,
            },
            crop_mask: {
                width: 2160,
                height: 1080,
                top_left: {
                    y: 0,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '125714361',
        },
        timezone: 'Europe/Berlin',
        id: '141105545485',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=141105545485',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '12844596163',
        num_children: 1,
        hide_end_date: false,
        start_date: '2022-05-21',
        end_time: '14:00',
        _type: 'destination_event',
        end_date: '2022-05-22',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/108',
                display_name: 'Sports & Fitness',
                localized: {
                    display_name: 'Sports & Fitness',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/15',
                display_name: 'Race or Endurance Event',
            },
        ],
        eventbrite_event_id: '141105545485',
        start_time: '12:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Wiese',
            venue_profile_id: null,
            address: {
                city: 'München',
                country: 'DE',
                region: 'BY',
                longitude: '11.577894300000025',
                localized_address_display:
                    'Oberbiberger Str. 120, 81547 München',
                postal_code: '81547',
                address_1: 'Oberbiberger Str. 120',
                latitude: '48.0931412',
                localized_multi_line_address_display: [
                    'Oberbiberger Str. 120',
                    '81547 München',
                ],
                localized_area_display: 'München',
            },
            venue_profile_url: '',
            id: '56993653',
        },
        image_id: '125714361',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '56993653',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Megamarsch München 2022',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/megamarsch-munchen-2022-tickets-141105545485',
        hide_start_date: false,
        summary: 'Megamarsch München',
        is_online_event: false,
        eid: '141105545485',
        published: '2021-02-11T08:30:12Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#ffffff',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F127485045%2F513197560043%2F1%2Foriginal.20210228-184608?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=712da943d4d78cbdd355eccb779c2d6b',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F127485045%2F513197560043%2F1%2Foriginal.20210228-184608?auto=format%2Ccompress&q=75&sharp=10&s=5463679932fcd3e622964d5bb9af816b',
                width: 2160,
                height: 1080,
            },
            crop_mask: {
                width: 2160,
                height: 1080,
                top_left: {
                    y: 0,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '127485045',
        },
        timezone: 'Europe/Vienna',
        id: '143582455991',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=143582455991',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '32531848963',
        num_children: 1,
        hide_end_date: false,
        start_date: '2022-05-26',
        end_time: '18:00',
        _type: 'destination_event',
        end_date: '2022-05-28',
        tags: [
            {
                prefix: 'EventbriteSubCategory',
                tag: 'EventbriteSubCategory/1004',
                display_name: 'Educators',
            },
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/101',
                display_name: 'Business & Professional',
                localized: {
                    display_name: 'Business & Professional',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/4',
                display_name: 'Convention',
            },
            {
                tag: 'OrganizerTag/Congress',
                display_name: 'Congress',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Slt',
                display_name: 'Slt',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/networking_event',
                display_name: 'networking_event',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/networking_online',
                display_name: 'networking_online',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/speech_and_language',
                display_name: 'speech_and_language',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '143582455991',
        start_time: '10:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Hotel Heffterhof',
            venue_profile_id: null,
            address: {
                city: 'Salzburg',
                country: 'AT',
                region: 'Salzburg',
                longitude: '13.0754755',
                localized_address_display:
                    '1-7 Maria-Cebotari-Straße, 5020 Salzburg',
                postal_code: '5020',
                address_1: '1-7 Maria-Cebotari-Straße',
                latitude: '47.8017102',
                localized_multi_line_address_display: [
                    '1-7 Maria-Cebotari-Straße',
                    '5020 Salzburg',
                ],
                localized_area_display: 'Salzburg',
            },
            venue_profile_url: '',
            id: '57482477',
        },
        image_id: '127485045',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '57482477',
        checkout_flow: 'widget',
        series_id: null,
        name: '11th ESLA Congress of Speech and Language Therapy',
        language: 'en-gb',
        url:
            'https://www.eventbrite.co.uk/e/11th-esla-congress-of-speech-and-language-therapy-tickets-143582455991',
        hide_start_date: false,
        summary:
            '11th ESLA Congress   of Speech and  Language Therapy. Priority Registration.',
        is_online_event: false,
        eid: '143582455991',
        published: '2021-02-28T20:06:32Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#ffffff',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F126834119%2F77121609577%2F1%2Foriginal.20210222-145837?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=b4454249216efc9b1b2796fb9eabe729',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F126834119%2F77121609577%2F1%2Foriginal.20210222-145837?auto=format%2Ccompress&q=75&sharp=10&s=c422be2ecec2b586f7256c11714fce4b',
                width: 2160,
                height: 1080,
            },
            crop_mask: {
                width: 2160,
                height: 1080,
                top_left: {
                    y: 0,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '126834119',
        },
        timezone: 'Europe/Berlin',
        id: '142523955989',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=142523955989',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '4896004797',
        num_children: 1,
        hide_end_date: false,
        start_date: '2021-06-16',
        end_time: '22:00',
        _type: 'destination_event',
        end_date: '2021-06-16',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/101',
                display_name: 'Business & Professional',
                localized: {
                    display_name: 'Business & Professional',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/13',
                display_name: 'Tournament',
            },
        ],
        eventbrite_event_id: '142523955989',
        start_time: '09:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Münchener Golf Club e.V. (Anlage Straßlach)',
            venue_profile_id: null,
            address: {
                city: 'Straßlach',
                country: 'DE',
                region: 'BY',
                longitude: '11.505491000000006',
                localized_address_display: 'Tölzer Straße 95, 82064 Straßlach',
                postal_code: '82064',
                address_1: 'Tölzer Straße 95',
                latitude: '47.986261',
                localized_multi_line_address_display: [
                    'Tölzer Straße 95',
                    '82064 Straßlach',
                ],
                localized_area_display: 'Straßlach',
            },
            venue_profile_url: '',
            id: '57295253',
        },
        image_id: '126834119',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '57295253',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Ladies Business Cup 2021 - München',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/ladies-business-cup-2021-munchen-tickets-142523955989',
        hide_start_date: false,
        summary:
            'Golf, Genuss und gute Gespräche.\nDas Networking Event für Damen.',
        is_online_event: false,
        eid: '142523955989',
        published: '2021-02-25T14:52:07Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#48698c',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F127552043%2F235976882689%2F1%2Foriginal.20210301-131403?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C583%2C3500%2C1750&s=d039a72096031832c2e0ac0d2d18a6d1',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F127552043%2F235976882689%2F1%2Foriginal.20210301-131403?auto=format%2Ccompress&q=75&sharp=10&s=5c653505c984ceeb0ffaa086a034d05c',
                width: 3500,
                height: 2333,
            },
            crop_mask: {
                width: 3500,
                height: 1750,
                top_left: {
                    y: 583,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '127552043',
        },
        timezone: 'Europe/Berlin',
        id: '143732109609',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=143732109609',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '15946937595',
        num_children: 1,
        hide_end_date: false,
        start_date: '2021-06-08',
        end_time: '20:00',
        _type: 'destination_event',
        end_date: '2021-06-08',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/101',
                display_name: 'Business & Professional',
                localized: {
                    display_name: 'Business & Professional',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/9',
                display_name: 'Class, Training, or Workshop',
            },
            {
                tag: 'OrganizerTag/Startup',
                display_name: 'Startup',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Gründung',
                display_name: 'Gründung',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/startupbasislager',
                display_name: 'startupbasislager',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '143732109609',
        start_time: '18:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Allgäu Digital - Digitales Zentrum Schwaben',
            venue_profile_id: null,
            address: {
                city: 'Kempten (Allgäu)',
                country: 'DE',
                region: 'BY',
                longitude: '10.3223527',
                localized_address_display:
                    'Keselstraße 16, 87435 Kempten (Allgäu)',
                postal_code: '87435',
                address_1: 'Keselstraße 16',
                latitude: '47.71853629999999',
                localized_multi_line_address_display: [
                    'Keselstraße 16',
                    '87435 Kempten (Allgäu)',
                ],
                localized_area_display: 'Kempten (Allgäu)',
            },
            venue_profile_url: '',
            id: '57789023',
        },
        image_id: '127552043',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '57789023',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Startup Basislager 04: Online-Marketing #2 Social Media',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/startup-basislager-04-online-marketing-2-social-media-tickets-143732109609',
        hide_start_date: false,
        summary:
            'Workshop für Gründer.innen und Startups zum Thema Social Media Marketing (Teil 2 von 2 zum Thema Online-Marketing)',
        is_online_event: false,
        eid: '143732109609',
        published: '2021-03-16T08:51:18Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#193a53',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F116950865%2F287686250115%2F1%2Foriginal.20201106-083206?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=130afd927985bd3bca4a627b32c51f72',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F116950865%2F287686250115%2F1%2Foriginal.20201106-083206?auto=format%2Ccompress&q=75&sharp=10&s=8bb5109745efd549ce6b8cad0b53970c',
                width: 2160,
                height: 1080,
            },
            crop_mask: {
                width: 2160,
                height: 1080,
                top_left: {
                    y: 0,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '116950865',
        },
        timezone: 'Europe/Berlin',
        id: '80218484647',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=80218484647',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '12844596163',
        num_children: 1,
        hide_end_date: false,
        start_date: '2021-11-06',
        end_time: '20:30',
        _type: 'destination_event',
        end_date: '2021-11-06',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/108',
                display_name: 'Sports & Fitness',
                localized: {
                    display_name: 'Sports & Fitness',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/15',
                display_name: 'Race or Endurance Event',
            },
        ],
        eventbrite_event_id: '80218484647',
        start_time: '07:30',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Start',
            venue_profile_id: null,
            address: {
                city: 'Nürnberg',
                country: 'DE',
                region: 'BY',
                longitude: '11.044644699999935',
                localized_address_display: 'Pommernstraße 10, 90451 Nürnberg',
                postal_code: '90451',
                address_1: 'Pommernstraße 10',
                latitude: '49.4118045',
                localized_multi_line_address_display: [
                    'Pommernstraße 10',
                    '90451 Nürnberg',
                ],
                localized_area_display: 'Nürnberg',
            },
            venue_profile_url: '',
            id: '51597130',
        },
        image_id: '116950865',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '51597130',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Megamarsch 50/12 Nürnberg 2021',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/megamarsch-5012-nurnberg-2021-tickets-80218484647',
        hide_start_date: false,
        summary: 'MEGAMARSCH 50/12',
        is_online_event: false,
        eid: '80218484647',
        published: '2019-11-07T09:53:00Z',
    },
    {
        image: {
            edge_color_set: true,
            edge_color: '#48698c',
            url:
                'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F127552309%2F235976882689%2F1%2Foriginal.20210301-131403?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C583%2C3500%2C1750&s=8d8a8dbab193446918d7f760016ef946',
            original: {
                url:
                    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F127552309%2F235976882689%2F1%2Foriginal.20210301-131403?auto=format%2Ccompress&q=75&sharp=10&s=519ba3222cf9a213fd0dc041380b7638',
                width: 3500,
                height: 2333,
            },
            crop_mask: {
                width: 3500,
                height: 1750,
                top_left: {
                    y: 583,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '127552309',
        },
        timezone: 'Europe/Berlin',
        id: '143732352335',
        tickets_url:
            'https://www.eventbrite.com/checkout-external?eid=143732352335',
        tickets_by: 'Eventbrite',
        primary_organizer_id: '15946937595',
        num_children: 1,
        hide_end_date: false,
        start_date: '2021-06-15',
        end_time: '20:00',
        _type: 'destination_event',
        end_date: '2021-06-15',
        tags: [
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/101',
                display_name: 'Business & Professional',
                localized: {
                    display_name: 'Business & Professional',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/9',
                display_name: 'Class, Training, or Workshop',
            },
            {
                tag: 'OrganizerTag/Startup',
                display_name: 'Startup',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/Gründung',
                display_name: 'Gründung',
                prefix: 'OrganizerTag',
            },
            {
                tag: 'OrganizerTag/startupbasislager',
                display_name: 'startupbasislager',
                prefix: 'OrganizerTag',
            },
        ],
        eventbrite_event_id: '143732352335',
        start_time: '18:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Allgäu Digital - Digitales Zentrum Schwaben',
            venue_profile_id: null,
            address: {
                city: 'Kempten (Allgäu)',
                country: 'DE',
                region: 'BY',
                longitude: '10.3223527',
                localized_address_display:
                    'Keselstraße 16, 87435 Kempten (Allgäu)',
                postal_code: '87435',
                address_1: 'Keselstraße 16',
                latitude: '47.7185363',
                localized_multi_line_address_display: [
                    'Keselstraße 16',
                    '87435 Kempten (Allgäu)',
                ],
                localized_area_display: 'Kempten (Allgäu)',
            },
            venue_profile_url: '',
            id: '57971099',
        },
        image_id: '127552309',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '57971099',
        checkout_flow: 'widget',
        series_id: null,
        name: 'Startup Basislager 05: Vertriebsstrategie und Sales-Performance',
        language: 'de-de',
        url:
            'https://www.eventbrite.de/e/startup-basislager-05-vertriebsstrategie-und-sales-performance-tickets-143732352335',
        hide_start_date: false,
        summary:
            'Workshop für Gründer.innen und Startups zum Thema Sales-Performance und Vertriebsstrategie',
        is_online_event: false,
        eid: '143732352335',
        published: '2021-03-16T09:09:45Z',
    },
];
export const relatedEventsResponse = {
    pagination: {
        object_count: 1059,
        continuation:
            'AGWl1yGS1_S5Iiu76ftm90bhiaRWRqeWgegXY6Ncb7U-dgkp73iOHggotJKvy5hGy6PHRJLK6Jog',
        page_count: 106,
        page_size: 10,
        has_more_items: true,
        page_number: 1,
    },
    events: _destinationEventList,
};

export const relatedEventsFromThisOrganizerResponse = {
    pagination: {
        object_count: 10,
        continuation: 'eyJwYWdlIjogMn0',
        page_count: 4,
        page_size: 3,
        has_more_items: true,
        page_number: 1,
    },
    events: [
        {
            image: {
                edge_color_set: true,
                edge_color: '#e0e0e0',
                url:
                    'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F56833796%2F292890117973%2F1%2Foriginal.20190214-193210?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C16%2C524%2C262&s=fce782f7f424eb2b47ca15a900aff45b',
                original: {
                    url:
                        'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F56833796%2F292890117973%2F1%2Foriginal.20190214-193210?auto=format%2Ccompress&q=75&sharp=10&s=631eb7711a3782d6fbfc21a732067097',
                    width: 525,
                    height: 295,
                },
                crop_mask: {
                    width: 524,
                    height: 262,
                    top_left: {
                        y: 16,
                        x: 0,
                    },
                },
                aspect_ratio: '2',
                id: '56833796',
            },
            saves: {
                saved_by_you: false,
            },
            event_sales_status: {
                start_sales_date: {
                    timezone: 'Europe/Madrid',
                    local: '2019-02-14T00:00:00',
                    utc: '2019-02-13T23:00:00Z',
                },
                default_message: null,
                sales_status: 'on_sale',
                message_code: null,
                message: null,
                message_type: null,
            },
            timezone: 'Europe/Madrid',
            id: '56591312138',
            tickets_url:
                'https://www.evbqa.com/checkout-external?eid=56591312138',
            tickets_by: 'Eventbrite',
            primary_organizer_id: '18840527927',
            hide_end_date: false,
            start_date: '2023-09-18',
            end_time: '22:00',
            status: 'live',
            _type: 'destination_event',
            ticket_availability: {
                is_sold_out: false,
                is_free: true,
                minimum_ticket_price: {
                    currency: 'USD',
                    major_value: '0.00',
                    value: 0,
                    display: '0.00 USD',
                },
                has_available_tickets: true,
                maximum_ticket_price: {
                    currency: 'USD',
                    major_value: '0.00',
                    value: 0,
                    display: '0.00 USD',
                },
            },
            end_date: '2023-09-18',
            tags: [],
            eventbrite_event_id: '56591312138',
            start_time: '19:00',
            primary_organizer: {
                _type: 'destination_profile',
                num_upcoming_events: null,
                name: 'CertificationAnswers',
                profile_type: 'organizer',
                num_followers: 6,
                url: 'https://www.evbqa.com/o/certificationanswers-18840527927',
                twitter: null,
                summary: null,
                num_saves: null,
                image_id: null,
                followed_by_you: false,
                facebook: null,
                num_collections: null,
                id: '18840527927',
                website_url: null,
                num_following: null,
            },
            series_id: null,
            image_id: '56833796',
            is_protected_event: false,
            is_cancelled: null,
            primary_venue_id: null,
            checkout_flow: 'widget',
            name:
                'Google Analytics Individuelle Qualifikation Prüfung Antworten',
            language: 'en-us',
            url:
                'https://www.evbqa.com/e/google-analytics-individuelle-qualifikation-prufung-antworten-tickets-56591312138',
            hide_start_date: false,
            summary:
                'Google Analytics Individuelle Qualifikation Prüfung Antworten',
            is_online_event: true,
            eid: '56591312138',
            published: '2019-02-14T19:33:53Z',
        },
        {
            image: {
                edge_color_set: true,
                edge_color: '#6783ed',
                url:
                    'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F56832107%2F292890117973%2F1%2Foriginal.20190214-190743?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C16%2C524%2C262&s=dfa98c82133a963fa0d5f4ef8c4ef8ac',
                original: {
                    url:
                        'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F56832107%2F292890117973%2F1%2Foriginal.20190214-190743?auto=format%2Ccompress&q=75&sharp=10&s=69fa4368516e0a338d0f4dec1ed3758b',
                    width: 525,
                    height: 295,
                },
                crop_mask: {
                    width: 524,
                    height: 262,
                    top_left: {
                        y: 16,
                        x: 0,
                    },
                },
                aspect_ratio: '2',
                id: '56832107',
            },
            saves: {
                saved_by_you: false,
            },
            event_sales_status: {
                start_sales_date: {
                    timezone: 'Europe/Madrid',
                    local: '2019-02-14T00:00:00',
                    utc: '2019-02-13T23:00:00Z',
                },
                default_message: null,
                sales_status: 'on_sale',
                message_code: null,
                message: null,
                message_type: null,
            },
            timezone: 'Europe/Madrid',
            id: '56589053382',
            tickets_url:
                'https://www.evbqa.com/checkout-external?eid=56589053382',
            tickets_by: 'Eventbrite',
            primary_organizer_id: '18840527927',
            hide_end_date: false,
            start_date: '2023-09-25',
            end_time: '22:00',
            status: 'live',
            _type: 'destination_event',
            ticket_availability: {
                is_sold_out: false,
                is_free: true,
                minimum_ticket_price: {
                    currency: 'USD',
                    major_value: '0.00',
                    value: 0,
                    display: '0.00 USD',
                },
                has_available_tickets: true,
                maximum_ticket_price: {
                    currency: 'USD',
                    major_value: '0.00',
                    value: 0,
                    display: '0.00 USD',
                },
            },
            end_date: '2023-09-25',
            tags: [],
            eventbrite_event_id: '56589053382',
            start_time: '19:00',
            primary_organizer: {
                _type: 'destination_profile',
                num_upcoming_events: null,
                name: 'CertificationAnswers',
                profile_type: 'organizer',
                num_followers: 6,
                url: 'https://www.evbqa.com/o/certificationanswers-18840527927',
                twitter: null,
                summary: null,
                num_saves: null,
                image_id: null,
                followed_by_you: false,
                facebook: null,
                num_collections: null,
                id: '18840527927',
                website_url: null,
                num_following: null,
            },
            series_id: null,
            image_id: '56832107',
            is_protected_event: false,
            is_cancelled: null,
            primary_venue_id: null,
            checkout_flow: 'widget',
            name: 'Google Ads-Grundlagen Prüfung Antworten',
            language: 'en-us',
            url:
                'https://www.evbqa.com/e/google-ads-grundlagen-prufung-antworten-tickets-56589053382',
            hide_start_date: false,
            summary: 'Google Ads-Grundlagen Prüfung Antworten',
            is_online_event: true,
            eid: '56589053382',
            published: '2019-02-14T19:10:40Z',
        },
        {
            image: {
                edge_color_set: true,
                edge_color: null,
                url:
                    'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F57553798%2F292890117973%2F1%2Foriginal.20190227-193559?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C40%2C1280%2C640&s=d7ebf5b0e677eeed444e2a17dbb22268',
                original: {
                    url:
                        'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F57553798%2F292890117973%2F1%2Foriginal.20190227-193559?auto=format%2Ccompress&q=75&sharp=10&s=e41cba51a4c6adf17af8b1e3bd86a58f',
                    width: 1280,
                    height: 720,
                },
                crop_mask: {
                    width: 1280,
                    height: 640,
                    top_left: {
                        y: 40,
                        x: 0,
                    },
                },
                aspect_ratio: '2',
                id: '57553798',
            },
            saves: {
                saved_by_you: false,
            },
            event_sales_status: {
                start_sales_date: {
                    timezone: 'Europe/Madrid',
                    local: '2019-02-27T00:00:00',
                    utc: '2019-02-26T23:00:00Z',
                },
                default_message: null,
                sales_status: 'on_sale',
                message_code: null,
                message: null,
                message_type: null,
            },
            timezone: 'Europe/Madrid',
            id: '57633590621',
            tickets_url:
                'https://www.evbqa.com/checkout-external?eid=57633590621',
            tickets_by: 'Eventbrite',
            primary_organizer_id: '18840527927',
            hide_end_date: false,
            start_date: '2023-09-25',
            end_time: '22:00',
            status: 'live',
            _type: 'destination_event',
            ticket_availability: {
                is_sold_out: false,
                is_free: true,
                minimum_ticket_price: {
                    currency: 'USD',
                    major_value: '0.00',
                    value: 0,
                    display: '0.00 USD',
                },
                has_available_tickets: true,
                maximum_ticket_price: {
                    currency: 'USD',
                    major_value: '0.00',
                    value: 0,
                    display: '0.00 USD',
                },
            },
            end_date: '2023-09-25',
            tags: [],
            eventbrite_event_id: '57633590621',
            start_time: '19:00',
            primary_organizer: {
                _type: 'destination_profile',
                num_upcoming_events: null,
                name: 'CertificationAnswers',
                profile_type: 'organizer',
                num_followers: 6,
                url: 'https://www.evbqa.com/o/certificationanswers-18840527927',
                twitter: null,
                summary: null,
                num_saves: null,
                image_id: null,
                followed_by_you: false,
                facebook: null,
                num_collections: null,
                id: '18840527927',
                website_url: null,
                num_following: null,
            },
            series_id: null,
            image_id: '57553798',
            is_protected_event: false,
            is_cancelled: null,
            primary_venue_id: null,
            checkout_flow: 'widget',
            name: 'Google Ads Mobile Werbung Prüfung Antworten',
            language: 'en-us',
            url:
                'https://www.evbqa.com/e/google-ads-mobile-werbung-prufung-antworten-tickets-57633590621',
            hide_start_date: false,
            summary: 'Google Ads Mobile Werbung Prüfung Antworten',
            is_online_event: true,
            eid: '57633590621',
            published: '2019-02-27T19:37:40Z',
        },
    ],
};
// const relatedEventsWithSameOrganizer = relatedEventsResponse.events.concat(
//     relatedEventsFromThisOrganizerResponse.events,
// );
const relatedEventsWithSameOrganizer = (relatedEventsResponse.events as any[]).concat(
    relatedEventsFromThisOrganizerResponse.events,
);

export const relatedEventsWithSameOrganizerResponse = {
    ...relatedEventsResponse,
    events: relatedEventsWithSameOrganizer,
};

export const DESTINATION_RESPONSE = {
    pagination: {
        object_count: 2,
        continuation: null,
        page_count: 1,
        page_size: 10,
        has_more_items: false,
        page_number: 1,
    },
    events: [
        {
            image: {
                edge_color_set: true,
                edge_color: null,
                url:
                    'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068193%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=4bafbe8cca69507baa336787cc6116fd',
                original: {
                    url:
                        'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068193%2F89561036269%2F1%2Foriginal.png?auto=format%2Ccompress&q=75&sharp=10&s=35df755aff18ca2f97a9398bc40ca544',
                    width: null,
                    height: null,
                },
                crop_mask: {
                    width: 50000,
                    height: 50000,
                    top_left: {
                        y: 0,
                        x: 0,
                    },
                },
                aspect_ratio: '1',
                id: '87068193',
            },
            saves: {
                saved_by_you: true,
            },
            event_sales_status: {
                start_sales_date: {
                    timezone: 'America/Los_Angeles',
                    local: '2014-02-10T07:00:00',
                    utc: '2014-02-10T15:00:00Z',
                },
                default_message: null,
                sales_status: 'on_sale',
                message_code: null,
                message: null,
                message_type: null,
            },
            timezone: 'America/Los_Angeles',
            id: '10629780961',
            tickets_url:
                'https://www.evbqa.com/checkout-external?eid=10629780961',
            tickets_by: 'Eventbrite',
            primary_organizer_id: '6076001355',
            hide_end_date: false,
            start_date: '2038-01-01',
            end_time: '17:00',
            status: 'live',
            _type: 'destination_event',
            ticket_availability: {
                is_sold_out: false,
                is_free: false,
                minimum_ticket_price: {
                    currency: 'USD',
                    major_value: '25.00',
                    value: 2500,
                    display: '25.00 USD',
                },
                has_available_tickets: true,
                maximum_ticket_price: {
                    currency: 'USD',
                    major_value: '30.00',
                    value: 3000,
                    display: '30.00 USD',
                },
            },
            end_date: '2038-01-01',
            tags: [],
            eventbrite_event_id: '10629780961',
            start_time: '08:00',
            primary_venue: {
                _type: 'destination_venue',
                name: '',
                venue_profile_id: null,
                address: {
                    city: 'Reno',
                    country: 'US',
                    region: 'NV',
                    longitude: '-119.76055600000001',
                    localized_address_display:
                        '4955 Energy Way, Reno, NV 89502',
                    postal_code: '89502',
                    address_1: '4955 Energy Way',
                    latitude: '39.506628',
                    localized_multi_line_address_display: [
                        '4955 Energy Way',
                        'Reno, NV 89502',
                    ],
                    localized_area_display: 'Reno, NV',
                },
                venue_profile_url: '',
                id: '13258217',
            },
            primary_organizer: {
                _type: 'destination_profile',
                num_upcoming_events: null,
                name: 'University of Nevada Cooperative Extension',
                profile_type: 'organizer',
                num_followers: 27,
                url:
                    'https://www.evbqa.com/o/university-of-nevada-cooperative-extension-6076001355',
                twitter: null,
                summary:
                    'University of Nevada Cooperative Extension\r\n \r\nWho we are: We are the outreach arm of University of Nevada, Reno. We design and deliver community programs to Nevadans in partnership with other agencie...',
                num_saves: null,
                image_id: '5526431',
                followed_by_you: true,
                facebook: 'uncemastergardeners',
                num_collections: null,
                id: '6076001355',
                website_url: 'http://www.unce.unr.edu/',
                num_following: null,
            },
            series_id: null,
            image_id: '87068193',
            is_protected_event: false,
            is_cancelled: null,
            primary_venue_id: '13258217',
            checkout_flow: 'widget',
            name:
                'Book Purchase: Water-Efficient Landscaping in the Intermountain West',
            language: 'en-us',
            url:
                'https://www.evbqa.com/e/book-purchase-water-efficient-landscaping-in-the-intermountain-west-tickets-10629780961',
            hide_start_date: false,
            summary:
                'Book Purchase: Water-Efficient Landscaping in the Intermountain West',
            is_online_event: false,
            eid: 'ekmyym',
            published: '2014-03-21T16:40:57Z',
        },
        {
            image: {
                edge_color_set: true,
                edge_color: '#ffffff',
                url:
                    'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F5413189%2F89561036269%2F1%2Foriginal.jpg?w=206&auto=format%2Ccompress&q=75&sharp=10&s=bd95dfae88aa473f67188af4a314916b',
                original: {
                    url:
                        'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F5413189%2F89561036269%2F1%2Foriginal.jpg?auto=format%2Ccompress&q=75&sharp=10&s=19ea5d093c1d8adc8c2a28da88c0acaf',
                    width: null,
                    height: null,
                },
                crop_mask: null,
                aspect_ratio: '1.03',
                id: '5413189',
            },
            saves: {
                saved_by_you: true,
            },
            event_sales_status: {
                start_sales_date: {
                    timezone: 'America/Los_Angeles',
                    local: '2014-03-28T10:10:00',
                    utc: '2014-03-28T17:10:00Z',
                },
                default_message: null,
                sales_status: 'on_sale',
                message_code: null,
                message: null,
                message_type: null,
            },
            timezone: 'America/Los_Angeles',
            id: '11038260735',
            tickets_url:
                'https://www.evbqa.com/checkout-external?eid=11038260735',
            tickets_by: 'Eventbrite',
            primary_organizer_id: '6076001355',
            hide_end_date: false,
            start_date: '2038-01-01',
            end_time: '17:00',
            status: 'live',
            _type: 'destination_event',
            ticket_availability: {
                is_sold_out: false,
                is_free: false,
                minimum_ticket_price: {
                    currency: 'USD',
                    major_value: '5.00',
                    value: 500,
                    display: '5.00 USD',
                },
                has_available_tickets: true,
                maximum_ticket_price: {
                    currency: 'USD',
                    major_value: '8.00',
                    value: 800,
                    display: '8.00 USD',
                },
            },
            end_date: '2038-01-01',
            tags: [
                {
                    prefix: 'EventbriteCategory',
                    tag: 'EventbriteCategory/109',
                    display_name: 'Travel & Outdoor',
                    localized: {
                        display_name: 'Travel & Outdoor',
                    },
                },
                {
                    prefix: 'EventbriteFormat',
                    tag: 'EventbriteFormat/100',
                    display_name: 'Other',
                },
                {
                    tag: 'Master/Travel',
                    display_name: 'Travel',
                    prefix: 'Master',
                },
            ],
            eventbrite_event_id: '11038260735',
            start_time: '14:00',
            primary_organizer: {
                _type: 'destination_profile',
                num_upcoming_events: null,
                name: 'University of Nevada Cooperative Extension',
                profile_type: 'organizer',
                num_followers: 27,
                url:
                    'https://www.evbqa.com/o/university-of-nevada-cooperative-extension-6076001355',
                twitter: null,
                summary:
                    'University of Nevada Cooperative Extension\r\n \r\nWho we are: We are the outreach arm of University of Nevada, Reno. We design and deliver community programs to Nevadans in partnership with other agencie...',
                num_saves: null,
                image_id: '5526431',
                followed_by_you: true,
                facebook: 'uncemastergardeners',
                num_collections: null,
                id: '6076001355',
                website_url: 'http://www.unce.unr.edu/',
                num_following: null,
            },
            series_id: null,
            image_id: '5413189',
            is_protected_event: false,
            is_cancelled: null,
            primary_venue_id: null,
            checkout_flow: 'widget',
            name:
                'Book Purchase: Home Landscaping Guide for Lake Tahoe and Vicinity',
            language: 'en-us',
            url:
                'https://www.evbqa.com/e/book-purchase-home-landscaping-guide-for-lake-tahoe-and-vicinity-tickets-11038260735',
            hide_start_date: false,
            summary:
                'Home Landscaping Guide for Lake Tahoe and Vicinity\r\nWritten by: John Cobourn, Bill Carlos, John Christopherson, Sue Donaldson, Wayne Johnson, Richard Post, JoAnne Skelly and Ed Smith.\r\nEdited by: Ella Chavez, Alice Good, Ed Spoon and Claudene Wharton\r\nSponsored by: Backyard Conservation Program of Nevada Tahoe Conservation District, Tahoe Resource Conservation District and USDA Natural Resources Conservation Service; California Regional Water Quality Control Board, Lahontan Region; California Ta',
            is_online_event: true,
            eid: 'ekmzbc',
            published: '2014-03-28T17:18:47Z',
        },
    ],
};

export const FORMATTED_RESPONSE_FROM_DESTINATION = {
    events: [
        {
            id: '10629780961',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 2500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068193%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=4bafbe8cca69507baa336787cc6116fd',
            edgeColor: null,
            locationInfo: 'Reno, NV',
            startTime: '08:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name:
                'Book Purchase: Water-Efficient Landscaping in the Intermountain West',
            savedByYou: true,
            url:
                'https://www.evbqa.com/e/book-purchase-water-efficient-landscaping-in-the-intermountain-west-tickets-10629780961',
            isOnlineEvent: false,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
        {
            id: '11038260735',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F5413189%2F89561036269%2F1%2Foriginal.jpg?w=206&auto=format%2Ccompress&q=75&sharp=10&s=bd95dfae88aa473f67188af4a314916b',
            edgeColor: '#ffffff',
            locationInfo: '',
            startTime: '14:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name:
                'Book Purchase: Home Landscaping Guide for Lake Tahoe and Vicinity',
            savedByYou: true,
            url:
                'https://www.evbqa.com/e/book-purchase-home-landscaping-guide-for-lake-tahoe-and-vicinity-tickets-11038260735',
            isOnlineEvent: true,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
        {
            id: '10630354677',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 2500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068203%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=7286c86e796c60c8cfb3226a93a7a08b',
            edgeColor: null,
            locationInfo: '',
            startTime: '08:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name: 'Book Purchase: Evaluating Alternative Low-Water-Use Crops',
            savedByYou: false,
            url:
                'https://www.evbqa.com/e/book-purchase-evaluating-alternative-low-water-use-crops-tickets-10630354677',
            isOnlineEvent: true,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
        {
            id: '10630657583',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068223%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=8a2d334faff98bbd1722229921c25004',
            edgeColor: null,
            locationInfo: '',
            startTime: '08:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name: 'Book Purchase: Complete Guide to Home Canning',
            savedByYou: false,
            url:
                'https://www.evbqa.com/e/book-purchase-complete-guide-to-home-canning-tickets-10630657583',
            isOnlineEvent: true,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
    ],
};

// TODO Revisit after having Creator Collections real data
export const FORMATTED_RESPONSE_FROM_DESTINATION_COLLECTIONS: FormattedEventResponse = {
    events: [
        {
            id: '10629780961',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 2500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068193%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=4bafbe8cca69507baa336787cc6116fd',
            edgeColor: undefined,
            locationInfo: 'Reno, NV',
            startTime: '08:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name: 'Event that belongs to a Creator Collection 1',
            savedByYou: true,
            url:
                'https://www.evbqa.com/e/book-purchase-water-efficient-landscaping-in-the-intermountain-west-tickets-10629780961',
            isOnlineEvent: false,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
        {
            id: '11038260735',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F5413189%2F89561036269%2F1%2Foriginal.jpg?w=206&auto=format%2Ccompress&q=75&sharp=10&s=bd95dfae88aa473f67188af4a314916b',
            edgeColor: '#ffffff',
            locationInfo: '',
            startTime: '14:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name: 'Event that belongs to a Creator Collection 2',
            savedByYou: true,
            url:
                'https://www.evbqa.com/e/book-purchase-home-landscaping-guide-for-lake-tahoe-and-vicinity-tickets-11038260735',
            isOnlineEvent: true,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
        {
            id: '10630354677',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 2500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068203%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=7286c86e796c60c8cfb3226a93a7a08b',
            edgeColor: undefined,
            locationInfo: '',
            startTime: '08:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name: 'Event that belongs to a Creator Collection 3',
            savedByYou: false,
            url:
                'https://www.evbqa.com/e/book-purchase-evaluating-alternative-low-water-use-crops-tickets-10630354677',
            isOnlineEvent: true,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
        {
            id: '10630657583',
            minPrice: {
                currency: 'USD',
                currencyFormat: '¤#,##0.00',
                minPriceValue: 500,
            },
            isSoldOut: false,
            eventSalesStatus: {
                salesStatus: 'on_sale',
                message: '',
                messageType: '',
                messageCode: '',
            },
            imageUrl:
                'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068223%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=8a2d334faff98bbd1722229921c25004',
            edgeColor: undefined,
            locationInfo: '',
            startTime: '08:00',
            startDate: '2038-01-01',
            isFree: false,
            ticketsBy: 'Eventbrite',
            name: 'Event that belongs to a Creator Collection 4',
            savedByYou: false,
            url:
                'https://www.evbqa.com/e/book-purchase-complete-guide-to-home-canning-tickets-10630657583',
            isOnlineEvent: true,
            timezone: 'America/Los_Angeles',
            organizerId: '6076001355',
            organizerName: 'University of Nevada Cooperative Extension',
            organizerFollowerCount: 27,
        },
    ],
};
